import { LOCALE_NAMES_BY_CODE } from '@jouzen/ecom-components/consts';

import { getAssetUrl } from '@/utils/getAssetUrl';

import type { VideoTrackData } from './types/VideoTrackData';

const VideoTrack = ({ lang, src }: VideoTrackData) => {
  const label = LOCALE_NAMES_BY_CODE[lang];

  if (!label) throw new Error(`Unsupported video caption language: ${lang}`);

  return (
    <track
      data-cy="video_track"
      kind="subtitles"
      label={label}
      src={getAssetUrl(`video-captions/${src.replace(/^\/+/g, '')}`)}
      srcLang={lang}
    />
  );
};

export default VideoTrack;
